import { Input, InputProps } from 'modules/ui/atoms/Input'

const NumberInput = ({
  onChange,
  onBlur,
  onFocus,
  label,
  maxLength,
  value,
  error,
  dataId,
  required,
  inputRef,
  autoFocus,
}: InputProps) => {
  function checkNumberEvent(event: any) {
    // Retrieve the current value of the input.
    const key = event.key
    const value = event.target.value

    const ctrlDown = event.ctrlKey // Check if CTRL is pressed
    const cmdDown = event.metaKey // Check if Command (for Mac) is pressed

    // Allow backspace, delete, enter, left arrow, right arrow,
    // up arrow, down arrow, select all and tab.
    if (
      key === 'Backspace' ||
      key === 'Delete' ||
      key === 'Enter' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key == 'ArrowUp' ||
      key == 'ArrowDown' ||
      ctrlDown ||
      cmdDown ||
      key == 'Tab' ||
      key == '-'
    ) {
      return
    }

    // If the value already contains a decimal, prevent the user from
    // entering another one.
    if (key === '.' && value.indexOf('.') !== -1) {
      return true
    }

    // If the value already contains a comma, prevent the user from
    // entering another one.
    if (key === ',' && value.indexOf(',') !== -1) {
      return true
    }

    // Allow only numbers and decimals.
    if (!/[\d.,]/.test(key)) {
      return true
    }

    return
  }

  const handleOnKeyDown = (e: any) => {
    const result = checkNumberEvent(e)

    if (result) e.preventDefault()
  }

  return (
    <Input
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={handleOnKeyDown}
      label={label}
      maxLength={maxLength}
      error={error}
      type="number"
      dataId={dataId}
      required={required}
      inputRef={inputRef}
      autoFocus={autoFocus}
    />
  )
}

export default NumberInput
